module.exports = __webpack_public_path__ + "img/arrow-block-left.9136e9ea.svg";